import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useLanguage } from '../LanguageContext';

export const NotHelpfulMessage: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <ReactMarkdown
      components={{
        a: ({ node, children, ...props }) => (
          <a target="_blank" rel="noopener noreferrer" {...props}>
            {children}
          </a>
        ),
      }}
      className="chat-markdown"
    >
      {t('notHelpfulMessage')}
    </ReactMarkdown>
  );
}; 